import React, { FC } from 'react';

interface IProps {
  title?: string;
}

const LeaderboardHeader: FC<IProps> = props => {
  const { children, title } = props;

  return (
    <div className="leaderboard-header">
      <h3 className="leaderboard-header__title">{title}</h3>

      {children}
    </div>
  );
};

export default LeaderboardHeader;
